import React from "react";

function JobEngineerListMobile({
    JobID,
    tableData,
    isClosed,
    handleEditClick,
    removeRow,
    formatDateWithFns,
    activeDateFormat
}) {

    return (
        <div className="container-fluid p-2">

            {tableData.length === 0 ? (
                <div className="text-center text-muted mt-4">
                    No engineers assigned.
                </div>
            ) : (
                tableData.map((data, index) => (
                    <div
                        key={data.EngineerTimeID}
                        className="card shadow-sm mb-3"
                        onClick={
                            data.EngineerTimeID > 0 &&
                            (isClosed === "0" || isClosed === 0)
                                ? () => handleEditClick(data, index)
                                : undefined
                        }
                        style={{
                            cursor:
                                data.EngineerTimeID > 0 &&
                                (isClosed === "0" || isClosed === 0)
                                    ? "pointer"
                                    : "default"
                        }}
                    >
                        <div className="card-body p-3">

                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="mb-0 text-primary">
                                    {data.DisplayName}
                                </h6>

                               
                            </div>

                            <div className="row">

                                <div className="col-6 mb-2">
                                    <small className="text-muted">
                                        Begin Travel
                                    </small>
                                    <div>
                                        {data.DepartBaseDate}
                                       &nbsp;&nbsp;  
                                        {data.DepartBaseTime}
                                    </div>
                                </div>

                                <div className="col-6 mb-2">
                                    <small className="text-muted">
                                        End Travel
                                    </small>
                                    <div>
                                        {data.ReturnBaseDate}
                                        &nbsp;&nbsp;
                                        {data.ReturnBaseTime}
                                    </div>
                                </div>

                                <div className="col-6 mb-2">
                                    <small className="text-muted">
                                        Travel Hours
                                    </small>
                                    <div>{data.HoursTravel}</div>
                                </div>

                                <div className="col-6 mb-2">
                                    <small className="text-muted">
                                        Job Hours
                                    </small>
                                    <div>{data.HoursDate}</div>
                                </div>

                                <div className="col-6 mb-2">
                                    <small className="text-muted">
                                        Start Job
                                    </small>
                                    <div>
                                        {data.StartDate}
                                        &nbsp;&nbsp;
                                        {data.StartTime}
                                    </div>
                                </div>

                                <div className="col-6 mb-2">
                                    <small className="text-muted">
                                        Finish Job
                                    </small>
                                    <div>
                                        {data.EndDate}
                                        &nbsp;&nbsp;
                                        {data.EndTime}
                                    </div>
                                </div>

                                <div className="col-6">
                                    <small className="text-muted">
                                        Rate
                                    </small>
                                    <div>{data.PayRateID}</div>
                                </div>

                                <div className="col-6">
                                    <small className="text-muted">
                                        Other
                                    </small>
                                    <div>
                                        {data.Other ? "Yes" : "No"}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}

export default JobEngineerListMobile;